export const maxReRequestsWaitActivate = 20;
export const checkActivateTrialInterval = 3000;
